import AxiosConfig from './LensAxiosConfig'
import firebase from '../config/FirebaseConfig'

// ================================ TAG CRUD ================================ \\
const getAll = async (lensId) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/tags?lens_id=${lensId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const create = async (tag) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const tagPayload = {
    lens_id: tag.lensId,
    value: tag.value,
    color: tag.color
  }

  const { data } = await AxiosConfig.post(
    '/tags',
    tagPayload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const update = async (tagId, tagPayload) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.patch(
    `/tags/${tagId}`,
    tagPayload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const remove = async (tagId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.delete(
    `/tags/${tagId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

// ================================ TAG CREATIVE BINDING ================================ \\
const tagCreative = async (tags) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/tags/ad-creatives',
    tags,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  )

  return data
}

const unTagCreative = async (tags) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/tags/ad-creatives/delete',
    tags,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  )

  return data
}

const getTagsByCreativeHash = async (lensId, creativeHash) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/tags/ad-creatives?lens_id=${lensId}&creative_hash=${creativeHash}`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  )

  return data
}

export default {
  // Tag CRUD
  getAll,
  create,
  update,
  remove,
  // Tag Creative Binding
  tagCreative,
  unTagCreative,
  getTagsByCreativeHash
}
